import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { Observable } from "rxjs";
import { shareReplay } from "rxjs/operators";
import { LoaderActions } from "../../store/loader/actions";
import { ResultWithProgress } from "../loader/models";

export function useFileLoader<F extends any>(): (
  fn: Observable<ResultWithProgress<F>>
) => Promise<ResultWithProgress<F>> {
  const dispatch = useDispatch();

  return useCallback(
    (fn: Observable<ResultWithProgress<F>>) => {
      const post$ = fn.pipe(shareReplay(1));
      // Update state
      post$.subscribe(
        (event) => {
          if (event.status === "progress") {
            dispatch(LoaderActions.setFileLoader(event.data));
          }
        },
        () => dispatch(LoaderActions.clearLoader()),
        () => dispatch(LoaderActions.clearLoader())
      );

      return post$.toPromise();
    },
    [dispatch]
  );
}
